module.exports = "/assets/5b2f1751af8350f23688f9059bef742f.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/S5.png
// module id = 2930
// module chunks = 0